import { InternalNetworkCveRetestContract } from '@terra/shared-contracts-internal-network';
import { createTerraOrpcClient } from '@terra/shared-utils';

export const internalNetworkCveRetestClient = createTerraOrpcClient({
  contract: InternalNetworkCveRetestContract,
  serviceName: 'orchestrator',
});
